import { appStore } from '@tom-ui/utils'

export type SeverityType = 'success' | 'info' | 'warning' | 'error'

export class SnackbarStore {
  showMessage(message: string, severity: SeverityType) {
    appStore.setShowAlert(severity, message)
  }
}
